export const translatableConfig = [
  {
    name: 'languageExpression',
    category: 'Expressions',
  },

  {
    name: 'genericText',
    category: 'Locales',
    default: 'Please provide answer in ',
    isLocalizable: true,
  },
  {
    name: 'placeholderText',
    category: 'Locales',
    default: '',
    isLocalizable: true,
  },
  {
    name: 'validationErrorFieldText',
    category: 'Locales',
    default: 'Please provide proper value',
    isLocalizable: true,
  },
  {
    name: 'validationErrorText',
    category: 'Locales',
    default: 'Please provide proper value',
    isLocalizable: true,
  },
  {
    name: 'validationType',
    category: 'Validation',
    default: 'none',
    choices: ['none', 'email', 'url'],
  },
  {
    name: 'inputType',
    category: 'Validation',
    default: 'single',
    choices: ['single', 'multiline', 'editor'],
  },
];
